
    <ng-template>
      <div class="novo-overlay-panel" role="listbox" [id]="id" #panel>
        <ng-content></ng-content>
      </div>
    </ng-template>
  